export default __webpack_public_path__ + "static/media/Ni_2020-1-1.bd7ccae1.png";